import React, {Component} from 'react';
import {Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";
import './ManageCop.css'
import moment from "moment";
import {DatePicker} from "antd";
import {Checkbox, Form, Button} from 'semantic-ui-react'
import TxtLbl from "../../../../components/Input/Input/TxtLbl";
import DrpDwn from "../../../../components/Dropdown/Dropdown/DrpDwn";
import Lbl from "../../../../components/Label/Lbl";
import ImageUpload from "../../../../components/ImageUploader/ImageUploader";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
// import countries_list from '../../../../store/Reducer/Countries'
import * as common from "../../../../const/Common/CommonFunc";
import $ from "jquery";
import * as EmailValidator from "email-validator/index";
import Cookies from "js-cookie";
import axiosTags from "../../../../axios/axios_tag";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import apiConfig from "../../../../axios/axios_api_services";

const {RangePicker} = DatePicker;

function disabledDate(current) {
  return current && current < moment().startOf("day");
}

class App extends Component {
  state = {
    corporate_id: '',
    corporate_code: '',
    corporate_brc: '',
    corporate_name: '',

    address_id: '',
    address_line_1: '',
    address_line_2: '',
    city_town: '',
    district: '',
    province_state: '',
    zip: '',
    country: '',

    corporate_webaddress: '',
    corporate_email: '',
    corporate_domain: '',
    corporate_tel: '',

    bill_contact: '',
    bill_email: '',
    bill_mobile: '',

    tech_contact: '',
    tech_email: '',
    tech_mobile: '',
    isStatus: true,

    start_date: '',
    end_date: '',

    image_url: '',

    completeCorporate: false,
    completeContract: false,
    completeTech: false,
    completeBill: false,

  };
  fillData = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);
    axiosTags.get(apiConfig.CORPORATE_SELECT(this.props.usr_obj.corporateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          let data = response.data.corporate;
          this.setState({
            corporate_id: data.corporateId,
            corporate_code: data.corporateCode,
            corporate_brc: data.brc,
            corporate_name: data.corporateName,

            address_id: data.address.length === 0 ? 0 : data.address[0].addressId,
            address_line_1: data.address.length === 0 ? "-" : data.address[0].addressLine1,
            address_line_2: data.address.length === 0 ? "-" : data.address[0].addressLine2,
            city_town: data.address.length === 0 ? "-" : data.address[0].city,
            district: data.address.length === 0 ? "-" : data.address[0].district,
            province_state: data.address.length === 0 ? "-" : data.address[0].state,
            zip: data.address.length === 0 ? "-" : data.address[0].postalCode,
            country: data.address.length === 0 ? "-" : data.address[0].country,

            corporate_webaddress: data.webAddress ?  data.webAddress : "",
            corporate_email: data.email,
            corporate_domain: data.emailDomain ?  data.emailDomain : "",
            corporate_tel: data.contactNo,

            bill_contact: data.billingContact,
            bill_email: data.billEmail,
            bill_mobile: data.billMobile,

            tech_contact: data.techContact,
            tech_email: data.techEmail,
            tech_mobile: data.techMobile,

            isStatus: data.status === 1,

            start_date: data.contractStart,
            end_date: data.contractEnd,
            image_url: data.photoPath ? data.photoPath : "",
          });
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.fillData()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };
  removeBorders = () => {
    this.setState({
      completeCorporate: null,
      completeContract: null,
      completeTech: null,
      completeBill: null,
    })
  };
  isValidate = () => {
    this.removeBorders();

    let isCorporate = this.validateCorporate();
    if (isCorporate) {
      let isBill = this.validateBilling();
      if (isBill) {
        let isTech = this.validateTech();
        if (isTech) {
          let isContract = this.validateContract();
          if (isContract) {
            this.updateCorporate()
          }
        }
      }
    }
    console.log(this.state.corporate_domain);
  };
  updateCorporate = () => {
    let corporate_code = this.state.corporate_code.trim();
    let corporate_brc = this.state.corporate_brc.trim();
    let corporate_name = this.state.corporate_name.trim();
    let address_line_1 = this.state.address_line_1.trim();
    let address_line_2 = this.state.address_line_2.trim();
    let city_town = this.state.city_town.trim();
    let district = this.state.district.trim();
    let province_state = this.state.province_state.trim();
    let zip = this.state.zip.trim();
    let country = this.state.country;
    let corporate_webaddress = this.state.corporate_webaddress.trim();
    let corporate_email = this.state.corporate_email.trim();
    let corporate_domain = this.state.corporate_domain.trim();
    let corporate_tel = this.state.corporate_tel.trim();

    let bill_contact = this.state.bill_contact.trim();
    let bill_email = this.state.bill_email.trim();
    let bill_mobile = this.state.bill_mobile.trim();

    let tech_contact = this.state.tech_contact.trim();
    let tech_email = this.state.tech_email.trim();
    let tech_mobile = this.state.tech_mobile.trim();
    let isStatus = this.state.isStatus ? 1 : 0;

    let start_date = this.state.start_date;
    let end_date = this.state.end_date;

    let visitor_service = this.state.visitor_service;
    let park_service = this.state.park_service;

    let service_array = [];

    if (park_service) {
      service_array.push(1)
    }

    if (visitor_service) {
      service_array.push(2)
    }

    const obj = {
      "corporateId": this.state.corporate_id,
      "corporateCode": corporate_code,
      "corporateName": corporate_name,
      "brc": corporate_brc,

      "address": [
        {
          "addressId": this.state.address_id,
          "addressLine1": address_line_1,
          "addressLine2": address_line_2,
          "city": city_town,
          "district": district,
          "state": province_state,
          "postalCode": zip,
          "country": country,
        }
      ],
      "webAddress": corporate_webaddress,
      "email": corporate_email,
      "emailDomain": corporate_domain,
      "contactNo": corporate_tel,

      "billingContact": bill_contact,
      "billMobile": bill_mobile,
      "billEmail": bill_email,

      "techContact": tech_contact,
      "techEmail": tech_email,
      "techMobile": tech_mobile,

      "contractStart": new Date(start_date).getTime(),
      "contractEnd": new Date(end_date).getTime(),
      "status": isStatus,

      "services": service_array,
      "photoPath": this.props.image.length !== 0 ? this.props.image[0].result : this.state.image_url,
    };

    swal({
      title: "Do you want to update this " + corporate_name + " corporate?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    })
      .then((value) => {
        switch (value) {

          case "action":
            this.sendToBackend(obj, corporate_name);
            break;
          default:
        }
      });
  };
  sendToBackend = (obj, corporate_name) => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    this.props.spinnerHandler(true);
    axiosTags.post(apiConfig.CORPORATE, obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          console.log(response.data);
          console.log(obj);
          common.warningAlert("Corporate successfully updated - (" + corporate_name + ")", 0);
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        console.log(error);
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackend(obj, corporate_name)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };
  onChange = (date, dateString) => {
    if (dateString[0] === "" || dateString[1] === "") {
    } else {
      this.setState({
        start_date: new Date(dateString[0]),
        end_date: new Date(dateString[1]),
      })
    }
  };
  validateCorporate = () => {
    if (this.state.corporate_code.trim() === "" || this.state.corporate_brc.trim() === "" ||
      this.state.corporate_name.trim() === "" || this.state.address_line_1.trim() === "" ||
      this.state.city_town.trim() === "" || this.state.district.trim() === "" || this.state.province_state.trim() === "") {

      common.notifyMessage("Please enter corporate details (required fields)");
      this.setState({
        completeCorporate: true
      });
      return false
    } else {
      let condition_tel = true;
      let condition_web = true;
      let condition_email = true;
      let condition_domain = true;

      if (this.state.corporate_tel !== "") {
        if (this.state.corporate_tel.length >= 9) {
        } else {
          common.notifyMessage("Please enter valid mobile number", 0, 2);
          condition_tel = false
        }
      }
      // email validator
      let validateEmail = EmailValidator.validate(this.state.corporate_email.trim());
      if (!validateEmail) {
        common.notifyMessage("Please enter valid email address", 0, 2);
        condition_email = false
      }

      // web address
      let web_regx = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
      if (this.state.corporate_webaddress.trim() !== "" && !web_regx.test(this.state.corporate_webaddress)) {
        common.notifyMessage("Please enter valid web address", 0, 2);
        condition_web = false
      }

      //domain validator
      let validateDomain = /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/;
      if (this.state.corporate_domain.trim() !== "" && !validateDomain.test(this.state.corporate_domain)) {
        common.notifyMessage("Please enter valid Domain Name", 0, 2);
        condition_domain = false
      }

      if (condition_tel && condition_email && condition_web && condition_domain) {
        this.setState({
          completeCorporate: false
        });
        return true;
      } else {

        this.setState({
          completeCorporate: true
        });
        return false;
      }
    }
  };
  validateBilling = () => {
    if (this.state.bill_contact.trim() === "" || this.state.bill_mobile.trim() === "") {

      common.notifyMessage("Please enter billing contact details (required fields)");
      this.setState({
        completeBill: true
      });
      return false
    } else {
      let condition_tel = true;
      let condition_email = true;


      if (this.state.bill_mobile !== "") {
        if (this.state.bill_mobile.length >= 9) {
        } else {
          common.notifyMessage("Please enter valid billing mobile number", 0, 2);
          condition_tel = false
        }
      }
      // email validator
      if (this.state.bill_email.trim() !== "") {
        let validateEmail = EmailValidator.validate(this.state.bill_email.trim());
        if (!validateEmail) {
          common.notifyMessage("Please enter valid billing email address", 0, 2);
          condition_email = false
        }
      }

      if (condition_tel && condition_email) {
        this.setState({
          completeBill: false
        });
        return true
      } else {

        this.setState({
          completeBill: true
        });
        return false;
      }

    }
  };
  validateTech = () => {
    if (this.state.tech_contact.trim() === "" || this.state.tech_mobile.trim() === "") {

      common.notifyMessage("Please enter technical contact details (required fields)");
      this.setState({
        completeTech: true
      });
      return false
    } else {
      let condition_tel = true;
      let condition_email = true;

      if (this.state.tech_mobile !== "") {
        if (this.state.tech_mobile.length >= 9) {
        } else {
          common.notifyMessage("Please enter valid technical mobile number", 0, 2);
          condition_tel = false
        }
      }
      // email validator
      if (this.state.tech_email.trim() !== "") {
        let validateEmail = EmailValidator.validate(this.state.tech_email.trim());
        if (validateEmail) {
        } else {
          common.notifyMessage("Please enter valid technical email address", 0, 2);
          condition_email = false
        }
      }

      if (condition_tel && condition_email) {
        this.setState({
          completeTech: false
        });
        return true
      } else {

        this.setState({
          completeTech: true
        });
        return false;
      }
    }
  };
  validateContract = () => {
    if (this.state.start_date === "" || this.state.end_date === "" /*|| this.props.image.length === 0*/) {

      common.notifyMessage("Please enter contract details (required fields)");
      this.setState({
        completeContract: true
      });
      return false
    } else {
      this.setState({
        completeContract: false
      });
      return true
    }
  };
  handleChange = name => event => {
    let value = event.target.value;

    if (name === "corporate_tel") {
      let reg = /^\d+$/;
      if (reg.test(value) || value === "") {
        this.setState({
          [name]: event.target.value
        });
      }
    } else if (name === "bill_mobile") {
      let reg = /^\d+$/;
      if (reg.test(value) || value === "") {
        this.setState({
          [name]: event.target.value
        });
      }
    } else if (name === "tech_mobile") {
      let reg = /^\d+$/;
      if (reg.test(value) || value === "") {
        this.setState({
          [name]: event.target.value
        });
      }
    } else {
      this.setState({
        [name]: value
      });
    }

  };
  handleSelectHost = (e, {value}) => {
  };
  changeStatusHandler = () => {
    this.setState({
      isStatus: !this.state.isStatus
    })
  };
  districtOnChange = (e, {value}) => {
    this.setState({
      district: value
    })
  };
  provinceOnChange = (e, {value}) => {
    this.setState({
      province_state: value
    })
  };

  componentDidMount() {
    $('input').attr('autocomplete', 'off');
    this.fillData();
  }

  componentWillUnmount() {
    this.props.imageUploaderHandler([]);
  }

  render() {
    return (
      <div>
        <Row style={{padding: '10px'}}>
          <Col xs="12" lg={"6"} md={"6"} className={"padd_grap"}>
            <Card className={this.state.completeCorporate ? "border-danger" : null}>
              <CardHeader>
                CORPORATE DETAILS
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>

                  {/*corporate details*/}

                  <Form>
                    <Form.Group widths='equal'>
                      <TxtLbl
                        required
                        disable={true}
                        tagText={"Corporate Code"}
                        placeholder={"Corporate code"}
                        value={this.state.corporate_code}
                        onChange={this.handleChange('corporate_code')}
                      />

                      <TxtLbl
                        required
                        disable={true}
                        tagText={"Corporate BRC"}
                        placeholder={"Business registration certificate no"}
                        value={this.state.corporate_brc}
                        onChange={this.handleChange('corporate_brc')}
                      />

                    </Form.Group>

                    <Form.Group widths='equal'>
                      <TxtLbl
                        required
                        tagText={"Corporate Name"}
                        placeholder={"Corporate name"}
                        value={this.state.corporate_name}
                        onChange={this.handleChange('corporate_name')}
                      />
                    </Form.Group>
                  </Form>

                  {/*address*/}

                  <Form className={"row_gap"}>
                    <Form.Group widths='equal'>
                      <TxtLbl
                        required
                        tagText={"Address Line 1"}
                        placeholder={"Address Line 1"}
                        value={this.state.address_line_1}
                        onChange={this.handleChange('address_line_1')}
                      />

                      <TxtLbl
                        tagText={"Address Line 2"}
                        placeholder={"Address Line 2"}
                        value={this.state.address_line_2}
                        onChange={this.handleChange('address_line_2')}
                      />
                    </Form.Group>

                    <Form.Group widths='equal'>
                      <DrpDwn
                        required
                        tagText={"Province/State"}
                        value={this.state.province_state}
                        placeholder={"Province/State"}
                        options={this.props.provinces_list}
                        onChange={this.provinceOnChange}
                      />
                      {/*<TxtLbl*/}
                      {/*required*/}
                      {/*tagText={"Province/State"}*/}
                      {/*placeholder={"Province/State"}*/}
                      {/*value={this.state.province_state}*/}
                      {/*onChange={this.handleChange('province_state')}*/}
                      {/*/>*/}
                    </Form.Group>

                    <Form.Group widths='equal'>
                      <DrpDwn
                        required
                        tagText={"District"}
                        placeholder={"Select district"}
                        value={this.state.district}
                        options={this.props.districs_list}
                        onChange={this.districtOnChange}
                      />
                      {/*<TxtLbl*/}
                      {/*required*/}
                      {/*tagText={"District"}*/}
                      {/*placeholder={"District"}*/}
                      {/*value={this.state.district}*/}
                      {/*onChange={this.handleChange('district')}*/}
                      {/*/>*/}
                    </Form.Group>

                    <Form.Group widths='equal'>
                      <TxtLbl
                        required
                        tagText={"City/Town"}
                        placeholder={"City/Town"}
                        value={this.state.city_town}
                        onChange={this.handleChange('city_town')}
                      />
                    </Form.Group>

                    <Form.Group widths='equal'>
                      <TxtLbl
                        tagText={"Zip Code"}
                        placeholder={"Zip code"}
                        value={this.state.zip}
                        onChange={this.handleChange('zip')}
                      />
                    </Form.Group>

                    {/*<Form.Group widths='equal'>*/}
                    {/*<TxtLbl*/}
                    {/*disable={true}*/}
                    {/*tagText={"Country"}*/}
                    {/*placeholder={"Select country"}*/}
                    {/*value={this.state.country}*/}
                    {/*/>*/}
                    {/*</Form.Group>*/}
                  </Form>

                  {/*corporate web/email/tel*/}
                  <Form className={"row_gap"}>
                    <Form.Group widths='equal'>
                      <TxtLbl
                        tagText={"Web Address"}
                        placeholder={"Web"}
                        value={this.state.corporate_webaddress}
                        onChange={this.handleChange('corporate_webaddress')}
                      />

                      <TxtLbl
                        required
                        tagText={"Corporate Email"}
                        placeholder={"Email"}
                        value={this.state.corporate_email}
                        onChange={this.handleChange('corporate_email')}
                      />
                    </Form.Group>

                    <Form.Group widths='equal'>
                      <TxtLbl
                        tagText={"Domain Name"}
                        placeholder={"Domain Name"}
                        value={this.state.corporate_domain}
                        onChange={this.handleChange('corporate_domain')}
                      />
                    </Form.Group>

                    <Form.Group widths='equal'>
                      <TxtLbl
                        tagText={"Telephone"}
                        placeholder={"Telephone"}
                        value={this.state.corporate_tel}
                        onChange={this.handleChange('corporate_tel')}
                      />
                    </Form.Group>
                  </Form>

                </CardBody>
              </Collapse>
            </Card>
          </Col>

          {/*billing details*/}

          <Col xs="12" lg={"6"} md={"6"} className={"padd_grap"}>
            <Card className={this.state.completeBill ? "border-danger" : null}>
              <CardHeader>
                BILLING CONTACT PERSON DETAILS
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>

                  {/*billing details*/}
                  <Form>
                    <Form.Group widths='equal'>
                      <TxtLbl
                        required
                        tagText={"Billing Contact Person"}
                        placeholder={"Billing contact person"}
                        value={this.state.bill_contact}
                        onChange={this.handleChange('bill_contact')}
                      />

                      <TxtLbl
                        required
                        tagText={"Mobile"}
                        placeholder={"Mobile"}
                        value={this.state.bill_mobile}
                        onChange={this.handleChange('bill_mobile')}
                      />
                    </Form.Group>

                    <Form.Group widths='equal'>
                      <TxtLbl
                        tagText={"Email"}
                        placeholder={"Email"}
                        value={this.state.bill_email}
                        onChange={this.handleChange('bill_email')}
                      />
                    </Form.Group>
                  </Form>

                </CardBody>
              </Collapse>
            </Card>

            {/*tech details*/}

            <Card className={this.state.completeTech ? "border-danger" : null}>
              <CardHeader>
                TECHNICAL CONTACT PERSON DETAILS
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>

                  {/*tech details*/}
                  <Form>
                    <Form.Group widths='equal'>
                      <TxtLbl
                        required
                        tagText={"Technical Contact Person"}
                        placeholder={"Technical contact person"}
                        value={this.state.tech_contact}
                        onChange={this.handleChange('tech_contact')}
                      />

                      <TxtLbl
                        required
                        tagText={"Mobile"}
                        placeholder={"Mobile"}
                        value={this.state.tech_mobile}
                        onChange={this.handleChange('tech_mobile')}
                      />
                    </Form.Group>

                    <Form.Group widths='equal'>
                      <TxtLbl
                        tagText={"Email"}
                        placeholder={"Email"}
                        value={this.state.tech_email}
                        onChange={this.handleChange('tech_email')}
                      />
                    </Form.Group>
                  </Form>

                </CardBody>
              </Collapse>
            </Card>

            {/*contract details*/}

            <Card className={this.state.completeContract ? "border-danger" : null}>
              <CardHeader>
                CONTRACT DETAILS
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>

                  {/*contract details*/}
                  <Row>
                    <Col lg={6}>
                      <Lbl required>Contract Date range</Lbl>
                      {
                        this.state.start_date === "" || this.state.end_date === "" ? null :
                          <RangePicker
                            size={"mini"}
                            defaultValue={[moment(this.state.start_date), moment(this.state.end_date)]}
                            disabledDate={disabledDate}
                            disabled={true}
                            format="YYYY-MM-DD"
                            onChange={this.onChange}
                          />
                      }

                    </Col>

                    <Col lg={6} className={"text-align-path"}>
                      <Lbl required>Status</Lbl>
                      <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                checked={this.state.isStatus} toggle
                                label={this.state.isStatus ? 'Active' : 'Inactive'}/>
                    </Col>

                    <Col lg={12} className={"text-align-path col_gap"}>
                      <Lbl>Choose Corporate Logo</Lbl>
                      <ImageUpload image={this.state.image_url}/>
                    </Col>
                  </Row>

                </CardBody>
              </Collapse>
            </Card>

          </Col>

          <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
            <Button className="px-5" onClick={this.isValidate}>Update Corporate Details</Button>
          </Col>

        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  image: state.imageReducer.image,
  usr_obj: state.userReducer.user,
  provinces_list: state.addCorporateReducer.provinces,
  districs_list: state.addCorporateReducer.districs,

});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // reception meeting shedule handler
    imageUploaderHandler: (image) => dispatch(actionCreator.imageUploaderHandler(image))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
